export const artificialIntelligenceSchoolDataEurope = {
  tag: "AI",
  id: "aiSchool",
  url: "/ai-school",

  name: "AI School",
  description: `This program is designed to help you learn the application of important ML
  techniques for solving real business problems and make key data-driven decisions for business growth.
`,

  courses: [],

  testimony: {
    testimonierImage: "",
    testimonierName: "",
    testimonierTitle: "",
    testimonyDescription: ``,
  },

  article: [],
};
